import { edi } from '@/requests';
import { deleteRequest } from '@/core';

export default async function(tripId, subOrderId) {
	let url = edi.unscheduleOrder(tripId, subOrderId);
	let response = await deleteRequest(url, {}, {});
	return response;
}